import { create } from 'zustand';
import { INotificationCardNotification } from '../components/organism/NotificationCard';

interface INotificationsState {
  notifications: INotificationCardNotification[];
  page: number;
  hasNotificationPendindg: boolean;
  countNotificationPendindg: number;
  setNotifications: (notifications: INotificationCardNotification[]) => void;
  setPage: (page: number) => void;
  setHasNotificationPendindg: () => void;
}

export const useNotificationsStore = create<INotificationsState>(
  (set, get) => ({
    notifications: [],
    page: 1,
    countNotificationPendindg: 1,
    hasNotificationPendindg: false,
    setNotifications: (notifications = []) => {
      const existsNotificationNotSeen = notifications.filter(
        (it) => !it.seenDate
      ).length;
      const list = get().notifications;
      const newNotifications = notifications.filter(
        (it) => !list.find((n) => n.id === it.id)
      );

      set({
        notifications: [...list, ...newNotifications],
        hasNotificationPendindg: existsNotificationNotSeen > 0,
        countNotificationPendindg: existsNotificationNotSeen,
      });
    },
    setPage: (page) => set({ page }),
    setHasNotificationPendindg: () => {
      set({ hasNotificationPendindg: false });
    },
  })
);
